import { createActionTypes } from '.'

export const LOAD_LANGUAGE = createActionTypes('LOAD_LANGUAGE')
export const FETCH_USER = createActionTypes('FETCH_USER')
export const UPDATE_USER = createActionTypes('UPDATE_USER')
export const FETCH_MAIN_USER = createActionTypes('FETCH_MAIN_USER')
export const FETCH_MULTI_USERS = createActionTypes('FETCH_MULTI_USERS')
export const FETCH_INVITED_USERS = createActionTypes('FETCH_INVITED_USERS')
export const DELETE_INVITED_USER = createActionTypes('DELETE_INVITED_USER')
export const DELETE_MULTI_USER = createActionTypes('DELETE_MULTI_USER')
export const UPDATE_USER_PREFERENCES = createActionTypes(
  'UPDATE_USER_PREFERENCES',
)
export const UPDATE_LIFETIME_REMINDER_MODAL = createActionTypes(
  'UPDATE_LIFETIME_REMINDER_MODAL',
)
export const UPDATE_NAVIGATION_CHANGE_MODAL = createActionTypes(
  'UPDATE_NAVIGATION_CHANGE_MODAL',
)

export const UPDATE_AIW_PLAN_MODAL = createActionTypes('UPDATE_AIW_PLAN_MODAL')

export const UPDATE_LOGIN_LIMIT_MODAL = createActionTypes(
  'UPDATE_LOGIN_LIMIT_MODAL',
)

export const UPDATE_ATP_CROSS_SELL_MODAL = createActionTypes(
  'UPDATE_ATP_CROSS_SELL_MODAL',
)

export const UPDATE_USER_FAMILIAR_WITH_BANNER = createActionTypes(
  'UPDATE_USER_FAMILIAR_WITH_BANNER',
)

export const UPDATE_USER_SMART_THUMB_POPUP = createActionTypes(
  'UPDATE_USER_SMART_THUMB_POPUP',
)

export const UPDATE_USER_LIMITS = createActionTypes('UPDATE_USER_LIMITS')

export const FETCH_SUBSCRIPTION = createActionTypes('FETCH_SUBSCRIPTION')
export const FETCH_USER_LIMITS = createActionTypes('FETCH_USER_LIMITS')
export const FETCH_ADDONS = createActionTypes('FETCH_ADDONS')

export const CLOSE_UPDATE_BILLING_INFO_ALERT = createActionTypes(
  'CLOSE_UPDATE_BILLING_INFO_ALTER',
)

export const SET_EXTRA_HEADER_HEIGHT = createActionTypes(
  'SET_EXTRA_HEADER_HEIGHT',
)

export const DETECT_ADBLOCKER = createActionTypes('DETECT_ADBLOCKER')

export const CLOSE_ADBLOCK_MODAL = createActionTypes('CLOSE_ADBLOCK_MODAL')

export const updateUserWithBannerStatus = () => ({
  type: UPDATE_USER_FAMILIAR_WITH_BANNER.action,
})

export const updateUserWithSmartThumbup = () => ({
  type: UPDATE_USER_SMART_THUMB_POPUP.action,
})

export const loadLanguage = () => ({
  type: LOAD_LANGUAGE.action,
})

export const loadLanguageSuccess = () => ({
  type: LOAD_LANGUAGE.success,
})

export const fetchUser = (onComplete, updateProjects) => {
  return {
    type: FETCH_USER.action,
    onComplete,
    updateProjects,
  }
}

export const fetchUserSuccess = (payload) => ({
  type: FETCH_USER.success,
  payload,
})

export const updateUser = (payload) => ({
  type: UPDATE_USER.action,
  payload,
})

export const updateUserLimits = (payload) => ({
  type: UPDATE_USER_LIMITS.success,
  payload,
})

export const updateUserSuccess = (payload) => ({
  type: UPDATE_USER.success,
  payload,
})

export const fetchMainUser = () => ({
  type: FETCH_MAIN_USER.action,
})

export const fetchMainUserSuccess = (payload) => ({
  type: FETCH_MAIN_USER.success,
  payload,
})

export const fetchMainUserFailed = (payload) => ({
  type: FETCH_MAIN_USER.failed,
  payload,
})

export const fetchMultiUsers = () => ({
  type: FETCH_MULTI_USERS.action,
})

export const fetchMultiUsersSuccess = (payload) => ({
  type: FETCH_MULTI_USERS.success,
  payload,
})

export const fetchMultiUsersFailed = (payload) => ({
  type: FETCH_MULTI_USERS.failed,
  payload,
})

export const fetchInvitedUsers = () => ({
  type: FETCH_INVITED_USERS.action,
})

export const fetchInvitedUsersSuccess = (payload) => ({
  type: FETCH_INVITED_USERS.success,
  payload,
})

export const fetchInvitedUsersFailed = (payload) => ({
  type: FETCH_INVITED_USERS.failed,
  payload,
})

export const deleteInvitedUser = (payload) => ({
  type: DELETE_INVITED_USER.action,
  payload,
})

export const deleteInvitedUserSuccess = (payload) => ({
  type: DELETE_INVITED_USER.success,
  payload,
})

export const deleteInvitedUserFailed = (payload) => ({
  type: DELETE_INVITED_USER.failed,
  payload,
})

export const deleteMultiUser = (payload, onComplete) => ({
  type: DELETE_MULTI_USER.action,
  payload,
  onComplete,
})

export const updateUserPreferences = (payload) => ({
  type: UPDATE_USER_PREFERENCES.action,
  payload,
})

export const updateUserPreferencesSuccess = (payload) => ({
  type: UPDATE_USER_PREFERENCES.success,
  payload,
})

export const updateLifetimeReminderModal = (payload) => ({
  type: UPDATE_LIFETIME_REMINDER_MODAL.action,
  payload,
})

export const updateNavigationChangeModal = (payload) => ({
  type: UPDATE_NAVIGATION_CHANGE_MODAL.action,
  payload,
})

export const updateAIWPlanModal = (payload) => ({
  type: UPDATE_AIW_PLAN_MODAL.action,
  payload,
})

export const updateATPCrossSellModal = (payload) => ({
  type: UPDATE_ATP_CROSS_SELL_MODAL.action,
  payload,
})

export const fetchSubscription = () => ({
  type: FETCH_SUBSCRIPTION.action,
})

export const fetchUserLimits = () => ({
  type: FETCH_USER_LIMITS.action,
})

export const fetchSubscriptionSuccess = (payload) => ({
  type: FETCH_SUBSCRIPTION.success,
  payload,
})

export const fetchUserLimitsSuccess = () => ({
  type: FETCH_USER_LIMITS.success,
})

export const fetchAddons = () => ({
  type: FETCH_ADDONS.action,
})

export const fetchAddonsSuccess = (payload) => ({
  type: FETCH_ADDONS.success,
  payload,
})

export const updateLoginLimitModal = (payload, cb) => ({
  type: UPDATE_LOGIN_LIMIT_MODAL.action,
  payload,
  cb,
})

export const closeUpdateBillingInfoAlter = () => ({
  type: CLOSE_UPDATE_BILLING_INFO_ALERT.action,
})

export const setExtraHeaderHeight = (payload) => ({
  type: SET_EXTRA_HEADER_HEIGHT.action,
  payload,
})

export const detectAdblockerSuccess = (payload) => ({
  type: DETECT_ADBLOCKER.success,
  payload,
})

export const closeAdblockerModal = () => ({
  type: CLOSE_ADBLOCK_MODAL.action,
})

export const UPDATE_PROMPT_MODAL = createActionTypes('UPDATE_PROMPT_MODAL')

export const updatePromptModal = (payload) => ({
  type: UPDATE_PROMPT_MODAL.action,
  payload,
})

export const closePromptModal = () => ({
  type: UPDATE_PROMPT_MODAL.canceled,
})
